import { z } from 'zod';

import { LevelSchema } from '../enums';
import { IdSchema } from './common';

/** Участник в составе — только публичные поля (BLUEPRINT 4.5: без телефона). */
export const MemberPublicSchema = z.object({
  userId: IdSchema,
  firstName: z.string(),
  photoUrl: z.string().url().nullable(),
  age: z.number().int().nullable(),
  districtName: z.string().nullable(),
  level: LevelSchema.nullable(),
  isCaptain: z.boolean(),
  isReserve: z.boolean(),
  /** Серия явок «6 из 6» — единственное публичное из надёжности */
  streak: z.number().int().nonnegative(),
});
export type MemberPublic = z.infer<typeof MemberPublicSchema>;
